/**
 * Componente EmptyState
 * Wrapper para o Empty do Ant Design
 */

import React from "react";
import { Empty } from "antd";

const EmptyState = ({ icon: Icon, title, description, action, image, className }) => {
  return (
    <Empty
      image={image}
      description={
        <>
          {title && (
            <div style={{ fontSize: "1.125rem", fontWeight: 600, marginBottom: 8 }}>{title}</div>
          )}
          {description && <div>{description}</div>}
        </>
      }
      className={className}
    >
      {action}
    </Empty>
  );
};

export default EmptyState;
